import { MultipleInvoicePaymentDto } from './invoice-payment/dto/multiple-invoice-payment.dto';
import { Injectable } from '@angular/core';
import { ApiService, ApiCacheOptions } from '../../shared/index';

import { AgingSummaryRow } from './aging-summary.model';
import { MultipleInvoicePaymentResultDto } from './invoice-payment/dto/multiple-invoice-payment-result.dto';

@Injectable()
export class RevenueService {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public applyPaymentsToInvoices(dto: MultipleInvoicePaymentDto): Promise<MultipleInvoicePaymentResultDto> {
    return this._apiService.post('Revenue/ApplyPaymentToInvoices', dto);
  }

  public applyMultiplePaymentsToInvoices(dtos: Array<MultipleInvoicePaymentDto>): Promise<Array<MultipleInvoicePaymentResultDto>> {
    return this._apiService.post('Revenue/ApplyMultiplePaymentsToInvoices', dtos);
  }

  public getDuesAgingSummary(): Promise<Array<AgingSummaryRow>> {
    let url = 'Revenue/DuesAgingSummary';
    //let cacheOptions = new ApiCacheOptions;
    //cacheOptions.DisableCaching = true;

    return this._apiService.get(url, this._cacheOptions);
  }

  public getNonDuesAgingSummary(): Promise<Array<AgingSummaryRow>> {
    let url = 'Revenue/NonDuesAgingSummary';
    //let cacheOptions = new ApiCacheOptions;
    //cacheOptions.DisableCaching = true;

    return this._apiService.get(url, this._cacheOptions);
  }
}
